import { createContext, type MouseEvent, useContext } from 'react';

/**
 * On the Company page a click on an agent (org chart, live list, office) opens its side panel instead of
 * navigating away. Elsewhere there is no provider and the links behave as plain links.
 */
export const AgentSelectContext = createContext<((agentId: string) => void) | null>(null);

/** onClick for an agent link: select in place when a Company page is around (keeps cmd/ctrl-click). */
export function useAgentClick(agentId: string) {
  const select = useContext(AgentSelectContext);
  if (!select) return undefined;
  return (e: MouseEvent) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    select(agentId);
  };
}

export const useAgentSelect = () => useContext(AgentSelectContext);
